import { Dispatch } from "redux";
import ActionTypes from "../../../constants/ActionTypes";
import {
  ICreateFiltersListActions,
} from "./types";

export function createFilersListAction(params: any): ICreateFiltersListActions {
  return {
    type: ActionTypes.FILTERS_LIST.CREATE,
    payload: params
  };
}

export const clearFiltersListAction = () => (dispatch: Dispatch) => {
  return dispatch({
    type: ActionTypes.FILTERS_LIST.CLEAR,
  });
};
